import { SubmitOrderFailure } from 'components/ordering/SubmitOrderFailure'
import { SubmitOrderForm } from 'components/ordering/SubmitOrderForm'
import { SubmitOrderProgressView } from 'components/ordering/SubmitOrderProgressView'
import { SubmitOrderSuccess } from 'components/ordering/SubmitOrderSuccess'
import { TypeRoute } from 'core/TypeRoute'
import { useCurrentStore, useOrdering } from 'hooks'
import { ReactNode } from 'react'
import { generatePath } from 'react-router-dom'

interface Section {
  label: string
  name: string
  element: () => ReactNode
}

export interface StoreMenuPageState {
  sections: Section[]
  currentSectionIndex: number
}

export const SubmitOrderPage = () => {
  const { store } = useCurrentStore()

  const {
    submitOrderState: { isSubmitting, isSuccess, isError },
  } = useOrdering()

  return isError ? (
    <SubmitOrderFailure
      tryAgainUrl={generatePath(TypeRoute.SubmitOrder, {
        storeId: store?.id ?? '',
      })}
    />
  ) : isSuccess ? (
    <SubmitOrderSuccess
      backUrl={generatePath(TypeRoute.StoreInfo, { storeId: store?.id ?? '' })}
    />
  ) : (
    <>
      <SubmitOrderForm
        acceptOrderInfo={true}
        acceptFootnotes={store.footnotes_settings?.enable_footnotes ?? true}
        acceptTip={store.tip_settings?.enable_tip_guides ?? false}
        acceptPayment={store.accept_online_payment ?? false}
        acceptCustomerInfo={true}
        acceptPromoCode={true}
        backUrl={generatePath(TypeRoute.Ordering, { storeId: store.id })}
      />
      {isSubmitting && <SubmitOrderProgressView />}
    </>
  )
}
